import { Injectable } from '@angular/core';
import { NotificationService, NotificationSettings, NotificationRef } from '@progress/kendo-angular-notification';

/** Type definition for notification styles */
export const NotificationType = {
  Info: 'info' as const,
  Warning: 'warning' as const,
  Success: 'success' as const,
  Error: 'error' as const
};

/** Union type derived from NotificationType values */
export type NotificationStyleType = typeof NotificationType[keyof typeof NotificationType];

@Injectable({
  providedIn: 'root'
})
export class NotificationPopupService {

  protected notificationref: NotificationRef[]=[];
  constructor(private notificationService: NotificationService) {
  }

  /**
   * Displays a notification popup message
   * @param message - The message to display
   * @param type - The notification style type
   *
   * @example
   * this.notification.showNotification('Success!', NotificationType.Success);
   * or
   * this.notification.showNotification('Success!', 'success');
   */
  showNotification(message: string, type: NotificationStyleType, isbuttonNotification: boolean = false): void {
   
    let settings: NotificationSettings = {
      content: message
      , animation: { type: 'slide', duration: 400 }
      , position: { horizontal: 'right', vertical: 'bottom' }
      , type: { style: type, icon: true }
    };
    if (isbuttonNotification == true) {
      settings.cssClass = "button-notification";
      settings.closable = true;
    }
    const ref = this.notificationService.show(settings);

    if (isbuttonNotification == true) {
      this.notificationref.push(ref);
    }
  }

  /**
   * Hide's all the notification which are not auto closing it.
   */
  clearAllNotifications() {
    this.notificationref.forEach(ref => ref.hide());
    this.notificationref = []; 
  }


}
